/**
 * State used in rendering CardPreview.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
